var React = require('react');

function Pin (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2.4 13.205C-.384 10.323-.384 5.652 2.4 2.77a6.953 6.953 0 0110.076 0c2.782 2.882 2.782 7.553 0 10.435l-5.039 5.217L2.4 13.205zm5.037-2.217c1.6 0 2.897-1.344 2.897-3 0-1.657-1.297-3-2.897-3-1.6 0-2.897 1.343-2.897 3 0 1.656 1.297 3 2.897 3z","fill":"#00D789"}));
}

Pin.defaultProps = {"width":"15","height":"19","fill":"none"};

module.exports = Pin;

Pin.default = Pin;
